import { Observable }                   from 'rxjs';
import { CsHttpRequestOptions, Result } from '@cs/core';
import { IConfigService }               from '@cs/performance-manager/shared';
import {
	RequestDetails, RequestInitResponse, RequestCompleteResponse, DepartmentOption, BusinessUnitOption, RequestCaptcha
}                                       from './models';

export abstract class RequestAccessConfigService implements IConfigService {

	abstract readonly moduleName: string;
	abstract readonly supportEmail: string;

	/**
		* Step 1: Initialize request by sending email
		*/
	abstract initRequest(email: string, captcha: string, options?: CsHttpRequestOptions): Observable<Result<RequestInitResponse>>;

	/**
		* Step 2: Complete the request after email token verification
		*/
	abstract completeRequest(details: RequestDetails, token: string, options?: CsHttpRequestOptions): Observable<Result<RequestCompleteResponse>>;

	/**
		* Verify token from email link
		*/
	abstract verifyToken(token: string, options?: CsHttpRequestOptions): Observable<Result<boolean>>;

	/**
		* Get department options for dropdown
		*/
	abstract getDepartments(options?: CsHttpRequestOptions): Observable<Result<DepartmentOption[]>>;

	/**
		* Get business unit options for dropdown
		*/
	abstract getBusinessUnits(options?: CsHttpRequestOptions): Observable<Result<BusinessUnitOption[]>>;

	/**
		* Get status of a request (for future use)
		*/
	abstract checkStatus(requestId: string, options?: CsHttpRequestOptions): Observable<Result<any>>;

	/**
		* Initiate request access
		*/
	abstract initiateRequestAccess(): Observable<Result<RequestCaptcha>>;
}
